import React from "react";
import { CardImg } from "reactstrap";
import { NavLink } from "react-router-dom";

const Genius = ({ SelectedProduct, SelectedProductID, toggle }) => {
  const ExternalLink = () => {
    window.open('https://www.bookmebob.com/contact')
  }
  return (
    <div className="col-item mb-3 mt-3 col-md-12 col-lg-3">
      <div className="card" >
        <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
          <div className="price-top-part">
            <h5 className="mb-0 font-weight-semibold color-theme-1 mb-4">Genius</h5>
            <p className="mt-2 text-default" style={{ height: '85px' }}>Custom pricing for groups with more than 5 properties</p>
            <CardImg
              top
              src='https://static.wixstatic.com/media/e1bed3_e2d943f8e21140fc8708082aa61a46a7~mv2.png/v1/fill/w_123,h_123,al_c,q_85,usm_0.66_1.00_0.01/sam1.webp'
              alt="Card image cap"
              className="img-thumbnail border-0 rounded-circle list-thumbnail"
            />
          </div>
          <div className="text-center" style={{ marginTop: '104px' }}>
            <NavLink style={{ fontWeight: '700' }} to="#" className="btn btn-link btn-empty active" onClick={() => ExternalLink()}>
              REQUEST A QUOTE
              <i className="simple-icon-arrow-right" />
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Genius);
